import { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Button from '../../../../common/Button'
import InputText from '../../../../common/InputText'
import { postRequest, putRequest } from '../../../../../services/base'
import { NavContext } from '../../../../../context/global_context'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import { getLocalStorageData } from '../../../../../utils/LocalStorageAccess'
import { MAKE_ID } from '../../../../../constants/common'

const DEFAULT_FORM_VALUES = {
  name: '',
  make: '',
  system_id: '',
}

const SystemEditCreateForm = (props) => {
  const [state, dispatch] = useContext(NavContext)

  const [systemDetails, setSystemDetails] = useState(DEFAULT_FORM_VALUES)

  useEffect(() => {
    if (props?.selectedSystem?.id) {
      setSystemDetails(props?.selectedSystem)
    } else {
      setSystemDetails({
        ...DEFAULT_FORM_VALUES,
        make: getLocalStorageData(MAKE_ID),
      })
    }
  }, [props?.selectedSystem?.id])

  const saveSystemDetails = async (e) => {
    const form = e.target
    const formData = new FormData(form)
    let res = null
    if (props?.selectedSystem?.id) {
      res = await putRequest(
        `/api/system/${props?.selectedSystem?.id}/`,
        formData
      )
    } else {
      res = await postRequest(`/api/system/`, formData)
    }
    if (res?.status) {
      setSystemDetails({})
      props.onSave()
    } else {
      let msg = ''
      Object.keys(res).map((obj) => {
        if (msg) {
          msg += `, ${res[obj]}`
        } else {
          msg = `${res[obj]}`
        }
      })

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        setSystemDetails({})
        props.setShowModal(false)
        props.onClose()
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        {props.selectedSystem?.id
          ? 'Update Existing System'
          : 'Create New System'}
      </ModalHeader>
      <ModalBody>
        <div className="">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              saveSystemDetails(e)
            }}
          >
            <input
              type="hidden"
              value={props?.selectedSystem?.id ? false : true}
              name="is_create"
            />
            {props?.selectedSystem?.id && (
              <input
                type="hidden"
                name="id"
                value={props?.selectedSystem?.id}
              />
            )}
            <div className="flex">
              <div className="w-1/2">
                <InputText
                  name="system_id"
                  type="text"
                  label="System Id"
                  value={systemDetails.system_id}
                />
              </div>
              <div className="w-1/2">
                <InputText
                  name="name"
                  type="text"
                  label="Name"
                  value={systemDetails.name}
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/2">
                <InputText
                  name="make"
                  type="text"
                  label="Make Details"
                  value={
                    systemDetails.make
                      ? systemDetails.make
                      : getLocalStorageData(MAKE_ID)
                  }
                  onChange={(value) => {
                    setSystemDetails({ ...systemDetails, make: value })
                  }}
                  readOnly={getLocalStorageData(MAKE_ID) ? true : false}
                />
              </div>
            </div>

            <div className="flex justify-end">
              <div>
                <Button
                  type="submit"
                  className={`cursor-pointer btn my-4 w-full justify-end`}
                  onClick={(e) => {}}
                  value={'text'}
                  text={
                    props.selectedSystem?.id
                      ? 'Save System'
                      : 'Create New System'
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </ModalBody>
    </Modal>
  )
}

SystemEditCreateForm.propTypes = {
  selectedSystem: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
}

export default SystemEditCreateForm
